import { render, staticRenderFns } from "./talent5.vue?vue&type=template&id=72cc9206&scoped=true"
import script from "./talent5.vue?vue&type=script&lang=js"
export * from "./talent5.vue?vue&type=script&lang=js"
import style0 from "./talent5.vue?vue&type=style&index=0&id=72cc9206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc9206",
  null
  
)

export default component.exports